<template>
  <div id="ticket-main-section-left-column" class="ticket-main-section-left-column flex-grow-1">
    <ticket-intro-fixed v-if="showFixedIntro"></ticket-intro-fixed>
    <div class="container-fluid px-3 pt-3">
      <ticket-closing-note v-if="ticket.closing_note"></ticket-closing-note>
      <ticket-intro></ticket-intro>

      <div v-waypoint="{ active: true, callback: onIntroWaypoint }"></div>

      <!-- View Deleted -->
      <div class="form-group mb-1 view-deleted-wrapper">
        <label class="d-inline-block" for="viewDeleted">View Deleted Notes?</label>

        <b-form-checkbox class="d-inline-block"
                         v-model="show_deleted" name="check-button" switch>
        </b-form-checkbox>
      </div>
      <!-- / View Deleted -->

      <!--            <div class="section-title">-->
      <!--                <h3>Event Log</h3>-->
      <!--                <hr>-->
      <!--            </div>-->

      <div v-for="(item, i) in feed" :key="i">
        <ticket-note v-if="item.type === 'note'" :note="item.object"></ticket-note>
        <ticket-forwarding-log v-if="item.type === 'forwarding-log'"
                               :forwarding-log="item.object"></ticket-forwarding-log>

        <ticket-reply v-if="item.type === 'reply'"
                      :reply="item.object"></ticket-reply>

        <inbound-email v-if="item.type === 'inbound-email'"
                       :inbound-email="item.object"></inbound-email>

        <ticket-sms-log v-if="item.type === 'sms-log'"
                        :sms-log="item.object"></ticket-sms-log>

        <ticket-inbound-text-message v-if="item.type === 'inbound-text-message'"
                                     :inbound-text-message="item.object"></ticket-inbound-text-message>

        <ticket-expense v-if="item.type === 'expense'"
                        :expense="item.object"></ticket-expense>
      </div>

      <!-- Actions -->
      <ticket-actions v-show="selectedAction === null"></ticket-actions>
      <create-ticket-note v-if="selectedAction === 'add-note'"></create-ticket-note>
      <forward-ticket v-if="selectedAction === 'forward-ticket'"></forward-ticket>
      <send-sms v-if="selectedAction === 'send-sms'"></send-sms>
      <reply v-if="selectedAction === 'reply'"></reply>
      <!-- / Actions -->
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import TicketIntro from "./widgets/TicketIntro";
import TicketNote from "./widgets/TicketNote";
import TicketForwardingLog from "./widgets/TicketForwardingLog";
import TicketReply from "./widgets/TicketReply";
import InboundEmail from "./widgets/InboundEmail";
import TicketSmsLog from "./widgets/TicketSmsLog";
import TicketInboundTextMessage from "./widgets/TicketInboundTextMessage";
import TicketClosingNote from "./widgets/TicketClosingNote";
import TicketExpense from "./widgets/TicketExpense.vue";

import TicketActions from "./widgets/TicketActions";
import CreateTicketNote from "./widgets/CreateTicketNote";
import ForwardTicket from "./widgets/ForwardTicket";
import SendSms from "./widgets/SendSms";
import Reply from "./widgets/Reply";
import TicketIntroFixed from './widgets/TicketIntroFixed.vue';

export default {
  name: "TicketMainSectionLeftColumn",

  data() {
    return {
      showFixedIntro: false
    }
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      selectedAction: 'selectedAction',
      showDeleted: 'showDeleted',
      expenses: 'expenses'
    }),

    show_deleted: {
      get() {
        return this.showDeleted;
      },
      set(val) {
        this.setShowDeleted(Boolean(val));
      }
    },

    feed() {
      let feed = [];

      _.each(this.ticket.ticket_notes, function (note) {
        feed.push({
          type: 'note',
          object: note
        });
      });

      _.each(this.ticket.ticket_forwarding_logs, function (forwardingLog) {
        feed.push({
          type: 'forwarding-log',
          object: forwardingLog
        });
      });

      _.each(this.ticket.ticket_replies, function (reply) {
        feed.push({
          type: 'reply',
          object: reply
        });
      });

      _.each(this.ticket.inbound_emails, function (inboundEmail) {
        feed.push({
          type: 'inbound-email',
          object: inboundEmail
        });
      });

      _.each(this.ticket.ticket_sms_logs, function (smsLog) {
        feed.push({
          type: 'sms-log',
          object: smsLog
        });
      });

      _.each(this.ticket.inbound_text_messages, function (inboundTextMessage) {
        feed.push({
          type: 'inbound-text-message',
          object: inboundTextMessage
        });
      });

      _.each(this.expenses, function (expense) {
        feed.push({
          type: 'expense',
          object: expense
        });
      });

      return _.sortBy(feed, 'object.created_at');
    }
  },

  components: {
    TicketIntro,
    TicketNote,
    TicketActions,
    CreateTicketNote,
    ForwardTicket,
    Reply,
    TicketForwardingLog,
    TicketReply,
    InboundEmail,
    SendSms,
    TicketSmsLog,
    TicketInboundTextMessage,
    TicketClosingNote,
    TicketIntroFixed,
    TicketExpense
  },

  methods: {
    ...mapActions('ticketViewer', {
      setShowDeleted: 'setShowDeleted'
    }),

    onIntroWaypoint(e) {
      console.log(e);
      if (e.going == 'out') {
        this.showFixedIntro = true;
      } else {
        this.showFixedIntro = false;
      }
    }
  },

  mounted() {
    let container = document.getElementById('ticket-main-section-left-column');
    container.scrollTo({top: 0, behavior: "auto"});
  }
}
</script>

<style scoped lang="scss">
.ticket-main-section-left-column {
  position: relative;
  overflow-y: scroll;

  // &::-webkit-scrollbar {
    // display: none;
  // }
}

.view-deleted-wrapper {
  display: flex;
  justify-content: flex-end;

  label {
    margin-right: 10px;
  }
}
</style>
